export default __webpack_public_path__ + "65471a79a0cf6bd38cd787c0422cf2ce.png";